<app-page [notFound]="(btaxSupported$ | async) === false || (accountNotFound$ | async)" [showPageProgressBar]="loading">
    <div header>
        <h1>
            <span class="account-title">
                <ng-container *ngIf="account$ | async; else titlePlaceholders">{{ title$ | async }}</ng-container>
                <ng-template #titlePlaceholders>
                    <egov-text-ui-placeholder [length]="60" [lengthThreshold]="15"></egov-text-ui-placeholder>
                </ng-template>
            </span>
        </h1>
    </div>

    <div toolbarLeft class="toolbar-title">
        <ng-container *ngIf="account$ | async; else accountNumberPlaceholder">Account #{{ accountNumber$ | async }}</ng-container>
        <ng-template #accountNumberPlaceholder><egov-text-ui-placeholder>Account #00000</egov-text-ui-placeholder></ng-template>
    </div>

    <btax-account-actions
        toolbarRight
        class="option-buttons page-wide-options"
        color="white"
        [accountNumber]="accountNumber$ | async"
        [showPlaceholders]="loading"
    ></btax-account-actions>

    <ng-container pageContentNoColumn>
        <ng-container *ngIf="(accountDetailViewIsUnavailable$ | async) !== true">
            <app-data-jumbotron [items]="jumbotronItems$ | async"></app-data-jumbotron>
            <div class="content-column">
                <ng-container *ngIf="!loadError">
                    <btax-account-history [accountNumber]="accountNumber$ | async" [loaded]="(account$ | async) !== undefined"></btax-account-history>
                </ng-container>
                <app-content-placeholder
                    *ngIf="loadError"
                    type="error"
                    [showRetry]="loadErrorRetry"
                    (retry)="retry()"
                    customMessage="Error retrieving bill information."
                ></app-content-placeholder>
            </div>
        </ng-container>

        <div class="content-placeholder-message unavailable" *ngIf="(accountDetailViewIsUnavailable$ | async) === true">
            <mat-icon>block</mat-icon>
            <div class="text">
                <p>We are currently unable to display this page.</p>
                <p>Please, try again later.</p>
            </div>
        </div>
    </ng-container>

    <app-data-disclaimer afterContent [disclaimers]="disclaimers$ | async"></app-data-disclaimer>
</app-page>
